import { Button } from '@pesto/ui/components/Button';
import { ArrowLeft } from 'lucide-react';

import type { StatementListItem } from '../types/Statements.types';

import { StatementDetailsContent } from './StatementDetailsContent';
import { StatementPeriodNav } from './StatementPeriodNav';

interface StatementDetailViewProps {
  statementId: string;
  statement?: StatementListItem | null;
  statements: StatementListItem[];
  loading?: boolean;
  onBack: () => void;
  onSelectStatement: (statementId: string) => void;
  getLoanHref?: (loanId: string) => string;
}

export const StatementDetailView = ({
  statementId,
  statement,
  statements,
  loading,
  onBack,
  onSelectStatement,
  getLoanHref,
}: StatementDetailViewProps) => (
  <div className="flex flex-col gap-4">
    <div>
      <Button variant="ghost" size="sm" onClick={onBack}>
        <ArrowLeft className="mr-1.5 h-4 w-4" />
        Back to Statements
      </Button>
    </div>
    <StatementPeriodNav statements={statements} activeStatementId={statementId} onSelect={onSelectStatement} />
    <StatementDetailsContent statement={statement} loading={loading} getLoanHref={getLoanHref} />
  </div>
);
